import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import {
    TV_NIKE_STREAM_OVERVIEW,
    LIVE_STREAMS,
    TV_NIKE_ARCHIVE_OVERVIEW,
    TV_NIKE_HIGHLIGHTS_OVERVIEW
} from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function NikeTvTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();

    return (
        <HeaderTabsContainer>
            <TabButton
                route={TV_NIKE_STREAM_OVERVIEW}
                i18nCode="niu.niketv.menu.tvnike"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={LIVE_STREAMS}
                i18nCode="niu.niketv.menu.other-streams"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={TV_NIKE_ARCHIVE_OVERVIEW}
                i18nCode="niu.niketv.menu.archive"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={TV_NIKE_HIGHLIGHTS_OVERVIEW}
                i18nCode="niu.niketv.menu.highlights"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default NikeTvTabs;
